import React from "react";
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";
import Header from '../header';
import Footer from '../footer';
import './projects.css';
import Carousel from '../carousel';
import Beeah1 from '../../images/beeah.webp';
import Beeah2 from '../../images/beeah2.webp';
import Beeah3 from '../../images/beeah3.webp';
import Beeah4 from '../../images/beeah.webp';
import Beeah5 from '../../images/beeah2.webp';
function beeah() {
  return (
    
    <>
    <div className="boxed_wrapper" id="project">
    <Helmet>
        <title>BEE'AH Headquarters Acoustics Works - Moov Group</title>
        <meta name="description" content=""/>
        <meta property="og:title" content="BEE'AH Headquarters Acoustics Works" />
        <meta property="og:description" content=""/>
        <meta property="og:image" content="../../images/moovgroup-office.webp" />
        <link rel="canonical" href="https://www.moovgroup.com/beeah-acoustics" />
        <link rel="alternate" href="https://www.moovgroup.com/beeah-acoustics" hreflang="en-GB" />
    </Helmet>
    <Header />
    <div id="moov">
    <section className="breadcrumb-section projects-bg">
        <div className="container">
            <h1 className="page-title">BEE'AH Headquarters</h1>
            <span className="page-tag">Complete Acoustics Works</span>
        </div>
    </section>
    
    <section className="portfolio-section section-gap-top" id="portfolio">
        <div className="container">
            
            <div className="portfolio-items">
		        <div className="portfolio-item portfolio-style-four">
		            <div className="row align-items-center">
				        <div className="col-lg-6 col-md-6">
				            <div className="portfolio-container1">
				               <h1 className="portfolio-previous">The Museum of Future, Dubai</h1>
				            </div>
				        </div>
				        <div className="col-lg-6 col-md-6">
				            <div className="portfolio-container2">
				                <Link to="/museum-of-the-future-acoustics" className="portfolio-next">Next &raquo;</Link>
				            </div>
                        </div>
                    </div>
                    <span className="line-footer"></span>
                </div>
            </div>
                        
            <div className="row portfolio-items portfolio-filter" id="portsub"  style={{position: "relative", height: "580px"}}>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design web" style={{position: "absolute", right: "0px", bottom: "0px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Beeah1} alt="Beeah - 1" />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/beeah-acoustics">BEE'AH Headquarters</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 filter-item game" style={{position: "absolute", right: "295px", bottom: "0px"}}>
                    <div className="portfolio-item big-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Beeah2} alt="Beeah - 2" />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/beeah-acoustics">BEE'AH Headquarters</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item web" style={{position: "absolute", right: "885px", bottom: "0px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Beeah3} alt="Beeah - 3" />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/beeah-acoustics">BEE'AH Headquarters</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design" style={{position: "absolute", right: "0px", bottom: "290px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Beeah4} alt="Beeah - 4" />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/beeah-acoustics">BEE'AH Headquarters</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item game web" style={{position: "absolute", right: "885px", bottom: "290px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Beeah5} alt="Beeah - 5" />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/beeah-acoustics">BEE'AH Headquarters</Link></h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className="recently-project-style2-area">
            <div className="container">
                <div className="sec-title text-center">
                    <div className="pro-title">Our Projects</div>
                    <p className="bottom-text">we have successfully completed more than 900 acoustic projects<br /> over the last 17 years across the Middle East.<br /> Have a glance at our recently compeleted projects</p>
                </div>
                <Carousel />
            </div>
        </section>
        </div>
    </div>
<Footer />
</>
  );
}

export default beeah;